import { lang as en } from "assets/lang/en";

const language = en;

export function getLanguageString(section, str) {
  const lang_section = section ? language[section] : language;

  if (typeof lang_section === "undefined")
    return "[" + (section ? section + "." : "") + str + "]";

  const lang_string = lang_section[str];
  if (typeof lang_string === "undefined")
    return "[" + (section ? section + "." : "") + str + "]";

  return lang_string;
}
export function stringExist(section, str) {
  const lang_section = section ? language[section] : language;
  return lang_section && typeof lang_section[str] !== "undefined";
}
